import React from "react";
import { Row } from "reactstrap";

/** One filter chip as FilterContainer passes it; `selected` is flipped in place. */
export type FilterInputChip = {
  label?: string;
  value: string;
  selected: boolean;
  inputChecker?: boolean;
};

export type FilterInputProps<T extends FilterInputChip = FilterInputChip> = {
  elem: T;
  checkBoxResult: (elem: T) => void;
};

const FilterInput = <T extends FilterInputChip>({ elem, checkBoxResult }: FilterInputProps<T>) => {
  const onChangeCheckBox = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checkBoxValue = e.target.checked;
    elem.selected = checkBoxValue;
    checkBoxResult(elem);
  };

  return (
    <>
      {!elem.inputChecker ? (
        <Row className="margin-filters">
          <div className="custom-control custom-checkbox">
            <input
              className="custom-control-input"
              id={elem.value}
              type="checkbox"
              value={elem.value}
              checked={elem.selected}
              onChange={onChangeCheckBox}
            />
            <label className="custom-control-label" htmlFor={elem.value}>
              {elem.label}
            </label>
          </div>
        </Row>
      ) : (
        <Row className="margin-filters">
          <label
            className="custom-toggle custom-toggle-primary mr-1"
            style={{ margin: "10px" }}
          >
            <input
              type="checkbox"
              name={elem.value}
              value={elem.value}
              checked={elem.selected}
              onChange={onChangeCheckBox}
            />
            <span
              className="custom-toggle-slider rounded-circle"
              data-label-off="No"
              data-label-on="Yes"
            />
          </label>
        </Row>
      )}
    </>
  );
};

export default FilterInput;
